import React from 'react';
import { renderVideo } from './shared/renderers';

export default function VideoBlock({ props = {}, theme }) {
  return renderVideo(props, theme);
}
